<template>
    <div class="lobbi-images-grid">
        <div class="images-items">
            <div class="grid-item" v-for="item in options[0].cards" :key="item.title" :style="'background-image:url(' + item + ')'"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'lobbi-images-grid',
        props: ['options'],
        data () {
            return {
            }
        },
    }
</script>

<style lang="scss">
    @import '@/styles/components/lobbi/lobbi-images-grid.scss';
    @import '@/styles/components/lobbi/respond/lobbi-images-grid-respond.scss';
</style>